import { useSelector } from 'react-redux';
import { Router } from '@gatsbyjs/reach-router';

import { Layout } from '@components';
import { LeadCollectionTemplate } from '@views/SelfService/LeadCollector/LeadCollectionTemplate';

const Orders = ({ location, isWebdevMobile, basepath }) => {
  const { prefixLanguage: language } = useSelector(({ appState }) => appState);
  return (
    <Layout
      theme="dark"
      location={location}
      backgroundColor="white"
      invertibleLinkTheme={!isWebdevMobile}
      hideReserve
      hideFooter
    >
      <Router primary={false} location={location} basepath={`${basepath}`}>
        <LeadCollectionTemplate path="/interested" basepath={basepath} />
      </Router>
    </Layout>
  );
};

export default Orders;
